export default __webpack_public_path__ + "static/media/footer_logo1.934f7cc9.jpeg";